import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { exhaustMap, take } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { LocalStorageService } from '../shared/local-storage.service';
import { Identifier } from '../shared/models/storage.models';
import { HelpersService } from '../shared/utils/helpers/helpers.service';
import { selectUser } from '../store/user/user.selectors';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private store: Store<any>,
    private helper: HelpersService,
    private localStorageService: LocalStorageService,
    private translateService: TranslateService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const skipInterceptor = req.headers.has('Skip-Interceptor');
    if (skipInterceptor) {
      const headers = req.headers.delete('Skip-Interceptor');
      return next.handle(req.clone({ headers }));
    }

    return this.store.select(selectUser).pipe(
      take(1),
      exhaustMap((user) => {
        const franchiseId = localStorage.getItem(Identifier.TYPE_FRANCHISE_ID);
        const currentCulture =
          this.localStorageService.getStorageItem(Identifier.TYPE_LANGUAGE).value ||
          this.translateService.getDefaultLang() ||
          'en-CA';

        const apiKey = environment.api_key;

        let headers = req.headers
          .append('X-Frame-Options', 'deny')
          .append('Access-Control-Allow-Origin', '*')
          .append('Accept-Language', currentCulture)
          .append('ClinicGroupFranchiseId', franchiseId || '');

        // `set`, not `append`: appending onto a request that already carries an ApiKey produces a
        // comma-joined value ("a,b"), which the API's AuthorizeByApiKeyAttribute feeds straight into
        // Guid.Parse — a 500 FormatException rather than a readable error. Same guard style as
        // Authorization below.
        // `get` rather than `has`, so an empty inherited value is replaced instead of preserved.
        if (!headers.get('ApiKey')) {
          headers = headers.set('ApiKey', apiKey || '');
        }

        if (headers.has('Content-Type') && headers.get('Content-Type') === '') {
          headers = headers.delete('Content-Type');
        } else {
          headers = headers.append('Content-Type', 'application/json');
        }

        if (!headers.has('Authorization')) {
          headers = headers.append(
            'Authorization',
            this.helper.userIsAuthenticated(user) ? 'Bearer ' + user.token : ''
          );
        }

        const modifiedReq = req.clone({
          //params: new HttpParams().set('auth', user.validToken),
          headers: headers,
        });
        return next.handle(modifiedReq);
      })
    );
  }
}
